import {
  NotAttendingSchoolCheckbox,
  NotAttendingSchoolConfirmDialog,
  useFormReadOnly,
  useNotAttendingSchoolConfirm,
} from '../../../../common';
import { EducationInfoSection } from './components';
import { useFetchTreatmentPlanV3EducationPage, useTreatmentPlanV3Education } from './hooks';
import { TreatmentPlanV3PageContent, TreatmentPlanV3PageLoadState } from '../components';

export default function EducationForm() {
  const { retry } = useFetchTreatmentPlanV3EducationPage();
  const {
    educationInfo,
    notAttendingSchool,
    isLoading,
    hasLoaded,
    hasLoadError,
    isSaving,
    isUpdating,
    update,
    setNotAttendingSchool,
  } = useTreatmentPlanV3Education();
  const readOnly = useFormReadOnly();
  const { isConfirmOpen, handleToggle, handleConfirm, closeConfirm } = useNotAttendingSchoolConfirm(
    {
      setNotAttendingSchool,
    },
  );

  return (
    <TreatmentPlanV3PageContent title="Education">
      <TreatmentPlanV3PageLoadState
        errorMessage="Unable to load education information. Please try again."
        hasLoaded={hasLoaded}
        hasLoadError={hasLoadError}
        onRetry={retry}
      >
        <NotAttendingSchoolCheckbox
          checked={notAttendingSchool}
          disabled={isLoading || readOnly || isSaving}
          onChange={handleToggle}
        />

        {notAttendingSchool ? null : (
          <EducationInfoSection
            disabled={isLoading}
            educationInfo={educationInfo}
            isUpdating={isUpdating}
            onUpdate={update}
          />
        )}

        <NotAttendingSchoolConfirmDialog
          open={isConfirmOpen}
          hasEducationInfo={educationInfo != null}
          confirmLoading={isSaving}
          onClose={closeConfirm}
          onConfirm={handleConfirm}
        />
      </TreatmentPlanV3PageLoadState>
    </TreatmentPlanV3PageContent>
  );
}
